import { createClient } from '@supabase/supabase-js';

// BACKEND INTEGRATION: Replace with your Supabase project URL and anon key
// These should be in .env.local as NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY
const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL || 'https://your-project.supabase.co';
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || 'your-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// BACKEND INTEGRATION: Supabase table schema reference
// Table: picks
//   id: uuid primary key
//   created_at: timestamptz
//   sport: text (NFL, NBA, MLB, NHL, NCAAF, NCAAB, Soccer, UFC)
//   league: text
//   game: text (e.g. "Chiefs vs Ravens")
//   game_time: timestamptz
//   bet_type: text (spread, moneyline, total, prop, parlay)
//   pick: text (e.g. "Chiefs -3.5")
//   odds: integer (American format e.g. -110, +150)
//   units: numeric(4,2)
//   result: text (pending, win, loss, push, void)
//   units_result: numeric(4,2) (positive for win, negative for loss)
//   notes: text
//   posted_at: timestamptz
//   odds_api_event_id: text
//
// Table: odds_cache
//   id: uuid primary key
//   fetched_at: timestamptz
//   sport_key: text
//   data: jsonb
//   is_stale: boolean

export type Pick = {
  id: string;
  created_at: string;
  sport: string;
  league: string;
  game: string;
  game_time: string;
  bet_type: 'spread' | 'moneyline' | 'total' | 'prop' | 'parlay';
  pick: string;
  odds: number;
  units: number;
  result: 'pending' | 'win' | 'loss' | 'push' | 'void';
  units_result: number | null;
  notes: string | null;
  posted_at: string;
  odds_api_event_id: string | null;
};

export type OddsCache = {
  id: string;
  fetched_at: string;
  sport_key: string;
  data: Record<string, unknown>;
  is_stale: boolean;
};